/* import __COLOCATED_TEMPLATE__ from './connect.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { StandalonePlatformDisplayName } from 'embercom/objects/standalone/constants';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Signature {
  Args: {};
}

export default class StandaloneSalesforceSettingsConnect extends Component<Signature> {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;

  get platform() {
    return this.finStandaloneService.salesforcePlatform;
  }

  get activeConfigurations() {
    return this.platform.configurations?.filter((config) => config.isConnected) ?? [];
  }

  get hasAnyConnectedConfiguration() {
    return this.activeConfigurations.length > 0;
  }

  get platformName() {
    return StandalonePlatformDisplayName[this.appService.mainStandalonePlatform.platformKey];
  }

  get platformIcon() {
    return this.appService.mainStandalonePlatform.icon;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Settings::Connect': typeof StandaloneSalesforceSettingsConnect;
    'standalone/salesforce/settings/connect': typeof StandaloneSalesforceSettingsConnect;
  }
}
